import Link from "next/link";
import { useEffect, useState } from "react";
import styles from "./DetailPagePagination.module.scss"
import DetailPagePaginationType from "./DetailPagePaginationType";
import { plt_microcms } from "../../../libs/plt_microcms";
import microCmsGetAuth from "../../../constants/apis/microCmsGetApiKey";

const DetailPagePagination = (props: DetailPagePaginationType) => {
  const { endpointId, contentId, categoryName } = props;
  const [postList, setPostList] = useState<any>();
  const [isPostListFetched, setIsPostListFetched] = useState(false);
  const [prevTitle, setPrevTitle] = useState<string>("");
  const [prevId, setPrevId] = useState<string>("");
  const [nextTitle, setNextTitle] = useState<string>("");
  const [nextId, setNextId] = useState<string>("");

  const client = plt_microcms(microCmsGetAuth.serviceDomain, microCmsGetAuth.apiKey);

  useEffect(() => {
    const getPostList = async () => {
      let response;
      if (categoryName) {
        response = await client.get({
          endpoint: endpointId,
          queries: {
            fields: "id,title",
            filters: `category[contains]${categoryName}`,
            limit: 1000,
            orders: "-publishedAt",
          },
        });
      } else {
        response = await client.get({
          endpoint: endpointId,
          queries: {
            fields: "id,title",
            limit: 1000,
            orders: "-publishedAt",
          },
        });
      }
      
      setPostList(response); // データをセット
      setIsPostListFetched(true);
    };
    getPostList();

    const updatePrevNext = async () => {
      if (postList) {
        const totalCount = postList.totalCount || 0;
        const currentIndex = postList.contents.findIndex(
          (content: any) => content.id === contentId
        );

        const prevContent = postList.contents[currentIndex - 1];
        const nextContent = postList.contents[currentIndex + 1];

        if (prevContent !== undefined) {
          setPrevTitle(prevContent.title);
          setPrevId(prevContent.id);
        } else {
          setPrevTitle("");
          setPrevId("");
        }

        if (nextContent !== undefined) {
          setNextTitle(nextContent.title);
          setNextId(nextContent.id);
        } else {
          setNextTitle("");
          setNextId("");
        }
      }
    };
    updatePrevNext();
  }, [contentId, endpointId, isPostListFetched]);

  return (
    <ul className={styles.prevNext}>
      {prevTitle && (
        <li className={styles.prevNext__prev}>
          <Link className={styles.prevNext__title} href={`?id=${prevId}`}>{prevTitle}</Link>
        </li>
      )}
      {nextTitle && (
        <li className={styles.prevNext__next}>
          <Link className={styles.prevNext__title} href={`?id=${nextId}`}>{nextTitle}</Link>
        </li>
      )}
    </ul>
  );
};

export default DetailPagePagination;
